// Vendors
import React from 'react';
// Components
import { ErrorAccordionComponent } from 'components/error-accordion/error-accordion.component';
// Types
import type { ErrorCodeComponentType } from './types/error-code.component.type';
// Utilities
import { isErrorDescriptionHidden } from 'providers/error/utils/error.utils';

const ErrorCodeComponent = ({ error }: ErrorCodeComponentType): React.ReactElement | null => {
  return isErrorDescriptionHidden(error) ? null : (
    <ErrorAccordionComponent {...{ error, description: error }} />
  );
};

export { ErrorCodeComponent };
